import { get } from 'lodash';
import { createSelector } from 'reselect';

import { getEntities } from '../../global-selectors';

export const selectHiddenCouponInput = createSelector(
  getEntities,
  entities => get(entities, 'hiddenCouponInput', true)
);
